export const DEFAULT_LANGUAGE = 'enGB';
export const FALLBACK_LANGUAGE = 'enGB';
export const SUPPORTED_LANGUAGES = [
  'enGB', // English
  'deDE', // German
  'esES', // Spanish
];

